goog.provide("shadow.js.shim.module$$mui$material$Tooltip$default");
shadow.js.shim.module$$mui$material$Tooltip$default = shadow.js.shim.module$$mui$material$Tooltip.default;
